import { useContext } from 'react';
import { LaunchOfferContext } from 'providers/LaunchOffer';

const useLaunchOffer = () => useContext(LaunchOfferContext);

export default useLaunchOffer;
